import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import { getTimelySessionUrlForTicJwtExchange } from '@timelyapp/integration-cloud-sdk/api';
import debug from 'utils/debug';

export interface TicAuthState {
  isAuthenticated: boolean;
  /** Timestamp when the user was authenticated */
  lastAuthenticatedAt: Date | null;
}
const initialState: TicAuthState = {
  isAuthenticated: false,
  lastAuthenticatedAt: null,
};
const ticAuthSlice = createSlice({
  name: 'ticAuth',
  initialState,
  reducers: {
    /** Set auth state */
    setTicAuthState: (state, { payload }: PayloadAction<Pick<TicAuthState, 'isAuthenticated'>>) => {
      const { isAuthenticated } = payload;
      const authSyncUrl = getTimelySessionUrlForTicJwtExchange();
      state.isAuthenticated = isAuthenticated;
      state.lastAuthenticatedAt = isAuthenticated ? new Date() : null;
      debug.template.auth(
        isAuthenticated ? `✅ TIC authenticated via ${authSyncUrl}` : '❌ Lost TIC authentication',
        payload
      );
    },
  },
});

export const { setTicAuthState } = ticAuthSlice.actions;

export default ticAuthSlice.reducer;
